export type { WordGridItem } from "#word-tiles-grid";
export { WordTilesGrid } from "#word-tiles-grid";
export { WordDetailsTilesRow } from "#word-details-tiles-row";
export { WordSectionExpansionButton } from "#word-section-expansion-button";
